import {
    Accordion,
    Alert,
    ListGroup,
    ListGroupItem,
    Stack
} from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import checkRoutingParams from './check-routing-params.js';
import CustomError from './custom-error.js';

export default function RoutingComponent({ emmid, snippet }) {
    const { routingtype, routingmode, routingurl, metarouterurl } = snippet;

    let errorMessage = null;
    let routersOrder;
    try {
        routersOrder = checkRoutingParams(snippet);
    } catch (e) {
        if (!(e instanceof CustomError)) {
            throw e;
        }
        errorMessage = e.message;
    }

    const network = snippet.arnavigationdata?.indoor?.mapmatching?.network
        || snippet.arnavigationdata?.outdoor?.mapmatching?.network;
    const itineraryToolUrl = `../itinerary/?emmid=${emmid}${network ? `&network=${network}` : ''}`;

    return (
        <Stack gap={2}
            id="routing">
            <div>Routers used in following order:</div>
            {errorMessage ? (
                <Alert variant="danger">{errorMessage}</Alert>
            ) : (
                routersOrder.map(({ name, mode, external, coverage }) => (
                    <Alert variant="success"
                        key={name}>
                        {external ? (
                            <>
                                <strong>{name}</strong> (external)
                            </>
                        ) : (
                            <>
                                <strong>{name}</strong> in <strong>{mode}</strong> mode
                                <br /> Coverage: {coverage}
                            </>
                        )}
                    </Alert>
                ))
            )}
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Raw JSON in snippet</Accordion.Header>
                    <Accordion.Body>
                        <pre>
                            {JSON.stringify(
                                {
                                    routingtype,
                                    routingmode,
                                    routingurl,
                                    metarouterurl
                                },
                                null,
                                2
                            )}
                        </pre>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Tools</Accordion.Header>
                    <Accordion.Body>
                        <ListGroup>
                            <ListGroupItem
                                action
                                href="https://docs.google.com/document/d/1sRg2ZmtI29ngMryHJYXMFMxHluvb6IMasynaC1Xx9PY"
                            >
                                Documentation on Google Doc
                            </ListGroupItem>
                            <ListGroupItem action
                                href={itineraryToolUrl}>
                                Itinerary tool
                            </ListGroupItem>
                        </ListGroup>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </Stack>
    );
}
RoutingComponent.propTypes = {
    emmid: PropTypes.number,
    snippet: PropTypes.object
};
